@if (filter) {
  <span>
    @if (hasOptions()) {
      <span>
        @switch (filter.key) {
          @case ('best_price') {
            <span>
              {{ getI18nKey(filter.key) | translate }}
            </span>
          }
          @case ('offer_ids') {
            <span>
              {{ getI18nKey(filter.key) | translate }}
              <span class="offer-ids-list"></span>
            </span>
          }
          @default {
            <span>
              {{ getI18nKey(filter.key, '1') | translate }}
              <span class="filter-option-value">
                {{ getFirstOptionValue() }}
              </span>
              {{ getI18nKey(filter.key, '2') | translate }}
            </span>
          }
        }
      </span>
    }
    @if (!hasOptions()) {
      <span>
        {{ getI18nKey(filter.key) | translate }}
      </span>
    }
  </span>
}
